<admin-header [primaryButtons]="headerPrimaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>
<div class="form-container">
	<dx-form class="m-3" [(formData)]="item" [showColonAfterLabel]="true" labelLocation="top" [readOnly]="readOnly">
		<dxi-item itemType="group" caption="Details">
			<dxi-item dataField="reason"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-item>
			<dxi-item dataField="isActive" editorType="dxCheckBox"></dxi-item>
		</dxi-item>
	</dx-form>
</div>